import { useState } from 'react';
import { listContacts } from 'services/Contact/contactServices';
import { sortByKey } from 'utils/utils';
import { totalCountReferredToContact } from 'services/generalServices';

export function useReferredToContact(isLead = false, contactType = '', isReferralEntity = false, pageLimit = 15, loadFullList = true) {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const searchAsync = async (e, paginationToken = '', paginationDirection = 'forward') => {
    try {
      setLoading(true);
      let limit = pageLimit;

      if (loadFullList) {
        // Get total count first only on initial load
        const totalCountResponse = await totalCountReferredToContact('contact', true);
        limit = totalCountResponse?.data || 20; // fallback to 20 if no data
      }

      const response = await listContacts({
        contactType,
        keyWord: e?.query,
        pageLimit: limit,
        excludeFromLoading: true,
        in_lead: isLead,
        is_referral_entity: isReferralEntity,
        pagination_direction: paginationDirection,
        pagination_token: paginationToken,
      });

      // Sort contacts alphabetically by first_name
      const sortedContacts = response?.data?.contacts ? sortByKey(response.data.contacts, 'first_name') : [];
      setResults(sortedContacts);
      setLoading(false);

      // Return full response data including pagination info
      return {
        contacts: sortedContacts,
        next_token: response?.data?.next_token || '',
        transition_token: response?.data?.transition_token || '',
      };
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
      return {
        contacts: [],
        next_token: '',
        transition_token: '',
      };
    }
  };

  return { contactList: results, searchAsync, loading, setResults };
}
